import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetQuestionnaireDocumentAssetsArchiveQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  type: Types.QuestionnaireType;
  year: Types.Scalars["Int"];
}>;

export type GetQuestionnaireDocumentAssetsArchiveQuery = {
  __typename?: "Query";
  questionnaire?: {
    __typename?: "Questionnaire";
    assetsArchive: string;
  } | null;
};

export const GetQuestionnaireDocumentAssetsArchiveDocument = gql`
  query getQuestionnaireDocumentAssetsArchive(
    $email: String!
    $type: QuestionnaireType!
    $year: Int!
  ) {
    questionnaire(email: $email, type: $type, year: $year) {
      assetsArchive
    }
  }
`;

/**
 * __useGetQuestionnaireDocumentAssetsArchiveQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireDocumentAssetsArchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireDocumentAssetsArchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireDocumentAssetsArchiveQuery({
 *   variables: {
 *      email: // value for 'email'
 *      type: // value for 'type'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetQuestionnaireDocumentAssetsArchiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQuestionnaireDocumentAssetsArchiveQuery,
    GetQuestionnaireDocumentAssetsArchiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQuestionnaireDocumentAssetsArchiveQuery,
    GetQuestionnaireDocumentAssetsArchiveQueryVariables
  >(GetQuestionnaireDocumentAssetsArchiveDocument, options);
}
export function useGetQuestionnaireDocumentAssetsArchiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQuestionnaireDocumentAssetsArchiveQuery,
    GetQuestionnaireDocumentAssetsArchiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQuestionnaireDocumentAssetsArchiveQuery,
    GetQuestionnaireDocumentAssetsArchiveQueryVariables
  >(GetQuestionnaireDocumentAssetsArchiveDocument, options);
}
export type GetQuestionnaireDocumentAssetsArchiveQueryHookResult = ReturnType<
  typeof useGetQuestionnaireDocumentAssetsArchiveQuery
>;
export type GetQuestionnaireDocumentAssetsArchiveLazyQueryHookResult =
  ReturnType<typeof useGetQuestionnaireDocumentAssetsArchiveLazyQuery>;
export type GetQuestionnaireDocumentAssetsArchiveQueryResult =
  Apollo.QueryResult<
    GetQuestionnaireDocumentAssetsArchiveQuery,
    GetQuestionnaireDocumentAssetsArchiveQueryVariables
  >;
